import { EMPTY_ARRAY } from '@e-socna/empty';
import type { Id } from '@e-socna/data-layer';

import type { SerializedBackgroundOperationKey } from './background-operation-key.type';

export interface UiState {
  readonly backgroundOperationKeys: readonly SerializedBackgroundOperationKey[];
  readonly isBackgroundOperationRunning: boolean;
  readonly visibleDataGridTokens: readonly Id[];
  readonly isDataGridVisible: boolean;
  readonly isImageEditorFullscreen: boolean;
  readonly isTextEditorFullscreen: boolean;
}

export const initialState: UiState = {
  backgroundOperationKeys: EMPTY_ARRAY,
  isBackgroundOperationRunning: false,
  visibleDataGridTokens: EMPTY_ARRAY,
  isDataGridVisible: false,
  isImageEditorFullscreen: false,
  isTextEditorFullscreen: false,
};
